/**
 * designed by yy(github.com/guaidashu)
 **/
import request from "./api";

export const getNtfList = () => {
  return request({url: 'http://game.kccpoc.io/metaapi/index/nftinfo', method: 'get'})
}
